<template>
  <section class="service-section">
    <div class="container">
      <!-- 顶部图标区域 -->
      <div class="top-icons">
        <div class="icon-item">
          <img src="@/assets/home/top_1.png" alt="弹性资源" class="top-icon-image">
          <span class="icon-title">弹性资源</span>
          <p class="icon-desc">业务生长的动态</p>
          <p class="flex">适配引擎</p>
        </div>
        <div class="icon-item">
          <img src="@/assets/home/top_2.png" alt="体系构建" class="top-icon-image">
          <span class="icon-title">体系构建</span>
          <p class="icon-desc">业务连续性的底</p>
          <p class="flex">层保障网</p>
        </div>
        <div class="icon-item">
          <img src="@/assets/home/top_3.png" alt="安全防护" class="top-icon-image">
          <span class="icon-title">安全防护</span>
          <p class="icon-desc">核心资产的纵深</p>
          <p class="flex">防御体系</p>
        </div>
        <div class="icon-item">
          <img src="@/assets/home/top_4.png" alt="轻资产运营源" class="top-icon-image">
          <span class="icon-title">轻资产运营源</span>
          <p class="icon-desc">资源效能释放的</p>
          <p class="flex">最优路径</p>
        </div>
      </div>
      <!-- 主要内容区域 -->
      <div class="main-content">
        <div class="text-section">
          <h2 class="main-title">云平台的核心<span class="color-back">价值优势</span></h2>
          <ul class="advantages-list">
            <li class="advantage-item">
              <span class="advantage-dot"></span>
              <span class="advantage-line"></span>
              <span class="advantage-text">弹性扩容，适配业务生长节奏</span>
            </li>
            <li class="advantage-item">
              <span class="advantage-dot"></span>
              <span class="advantage-line"></span>
              <span class="advantage-text">高可用架构，加固业务连续性防线</span>
            </li>
            <li class="advantage-item">
              <span class="advantage-dot"></span>
              <span class="advantage-line"></span>
              <span class="advantage-text">纵深安全防护，守护数据资产安全</span>
            </li>
            <li class="advantage-item">
              <span class="advantage-dot"></span>
              <span class="advantage-line"></span>
              <span class="advantage-text">轻资产运营，释放成本效能</span>
            </li>
            <li class="advantage-item">
              <span class="advantage-dot"></span>
              <span class="advantage-line"></span>
              <span class="advantage-text">AI赋能云平台：从"承载"到"智慧领航"</span>
            </li>
          </ul>
          <div class="buttons-section">
            <button class="carousel-btn">立即试用 -→</button>
            <button class="carousel-btn consult-btn">立即咨询 -→</button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 新增区域：双列流程与平台搭建 -->
    <div class="process-platform-section">
      <div class="process-platform-container">
        <!-- 左侧：精简核心全流程搭建 -->
        <div class="process-card">
          <h3 class="process-title">精简核心全流程搭建</h3>
          <ul class="process-list">
            <li class="process-item">
              <span class="process-bullet">•</span>
              <span class="process-text">需求诊断：结合业务场景、用户规模及发展规划，明确平台功能与资源需求。</span>
            </li>
            <li class="process-item">
              <span class="process-bullet">•</span>
              <span class="process-text">架构设计："前端-后端-数据层"协同架构，满足迭代需求。</span>
            </li>
            <li class="process-item">
              <span class="process-bullet">•</span>
              <span class="process-text">测试调试：经功能、性能、安全等多维度测试，排查问题。</span>
            </li>
            <li class="process-item">
              <span class="process-bullet">•</span>
              <span class="process-text">运维保障：快速响应异常，定期巡检更新，保障稳定运行。</span>
            </li>
          </ul>
          <div class="process-button-container">
            <button class="carousel-btn consult-btn">立即咨询 -→</button>
          </div>
        </div>
        
        <!-- 右侧：云平台搭建 -->
        <div class="platform-card">
          <h3 class="platform-title">云平台搭建</h3>
          <ul class="platform-list">
            <li class="platform-item">
              <span class="platform-bullet">•</span>
              <span class="platform-text">资源弹性调度：动态适配引擎</span>
            </li>
            <li class="platform-item">
              <span class="platform-bullet">•</span>
              <span class="platform-text">高可用体系构建：业务连续性的保障网</span>
            </li>
            <li class="platform-item">
              <span class="platform-bullet">•</span>
              <span class="platform-text">全链路安全防护：核心资产的防御体系</span>
            </li>
            <li class="platform-item">
              <span class="platform-bullet">•</span>
              <span class="platform-text">轻资产运营模式：资源释放的最优路径</span>
            </li>
          </ul>
          <div class="platform-button-container">
            <el-button type="primary" class="platform-button">立即试用 →</el-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiceSection",
  // 组件无需复杂的data和methods，主要为静态展示
}
</script>

<style scoped lang="scss">
.service-section {
  padding: 60px 0;
  background-color: #f8f9ff;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 顶部图标区域样式 */
.top-icons {
  display: flex;
  justify-content: center;
  gap: 120px;
  margin-bottom: 60px;
}

.icon-item {
  text-align: center;
}

.top-icon-image {
  width: 80px;
  height: 80px;
  margin: 0 auto 15px;
}

.icon-title {
  display: block;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  margin-top: 10px;
}

.icon-desc {
  font-size: 14px;
  color: #666;
  margin: 0;
}

/* 主要内容区域样式 */
.main-content {
  background-image: url('@/assets/home/top_back.png');
  background-color: white;
  border-radius: 16px;
  padding: 40px;
  display: flex;
  align-items: center;
  gap: 60px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.text-section {
  flex: 1;
}

.main-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
}

.color-back {
  color: #348CF8;
}

.advantages-list {
  list-style: none;
  padding: 0;
  margin-bottom: 40px;
}

.advantage-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  position: relative;
}

.advantage-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: #348CF8;
  border-radius: 50%;
  margin-right: 12px;
  position: relative;
  z-index: 2;
}

.advantage-line {
  width: 2px;
  background-color: #348CF8;
  flex-grow: 1;
  position: absolute;
  top: -7px;
  bottom: -23px;
  left: 5px;
  z-index: 1;
}

.advantage-text {
  font-size: 16px;
  color: #333;
}

.buttons-section {
  display: flex;
  gap: 20px;
}



/* 新增双列区域样式 */
.process-platform-section {
  margin-top: 18px;
}

.process-platform-container {
  display: flex;
  justify-content: center;
  gap: 15px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.process-card {
  flex: 5;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  background-image: url('@/assets/home/process_back.png');
 background-size: cover;
}

.platform-card {
  flex: 2;
  background-color: #348CF8;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.process-title {
  font-size: 22px;
  font-weight: bold;
  color: #348CF8;
  margin-bottom: 25px;
}

.platform-title {
  font-size: 22px;
  font-weight: bold;
  color: white;
  margin-bottom: 25px;
}

.process-list,
.platform-list {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.process-item,
.platform-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  line-height: 1.5;
}

.process-bullet {
  color: #323232;
  font-weight: bold;
  margin-right: 8px;
  margin-top: 2px;
  font-size: 20px;
}

.platform-bullet {
  color: white;
  font-weight: bold;
  margin-right: 8px;
  margin-top: 2px;
}

.process-text {
  font-size: 14px;
  color: #333;
  flex: 1;
}

.platform-text {
  font-size: 14px;
  color: white;
  flex: 1;
}

.process-button-container{
  text-align: center;
  padding-right: 238px;
}
.platform-button-container {
}

// .process-button {
//   border-color: #348CF8;
//   color: #348CF8;
//   padding: 12px 16px;
//   font-size: 16px;
//   border-radius: 8px;
//   background-color: transparent;
// }

// .process-button:hover {
//   background-color: #348CF8;
//   color: white;
// }

.platform-button {
  background-color: white;
  border-color: white;
  color: #348CF8;
  padding: 12px 16px;
  font-size: 16px;
  border-radius: 8px;
}

.platform-button:hover {
  background-color: #f0f8ff;
  border-color: #f0f8ff;
}

/* 右侧图片区域样式 - 保留原有的云平台结构样式 */
.image-section {
  flex: 1;
}

.cloud-platform-image {
  width: 100%;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cloud-structure {
  position: relative;
  width: 100%;
  height: 100%;
}

.cloud-block {
  position: absolute;
  background-color: rgba(144, 164, 174, 0.1);
  border: 1px solid rgba(76, 110, 226, 0.3);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.cloud-block:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(76, 110, 226, 0.2);
}

.cloud-block-1 {
  width: 120px;
  height: 200px;
  top: 50px;
  left: 0;
}

.cloud-block-2 {
  width: 120px;
  height: 150px;
  top: 20px;
  left: 140px;
}

.cloud-block-3 {
  width: 120px;
  height: 180px;
  top: 40px;
  left: 280px;
}

.cloud-block-4 {
  width: 100px;
  height: 80px;
  top: 160px;
  left: 180px;
}

.cloud-block-5 {
  width: 100px;
  height: 60px;
  top: 220px;
  left: 70px;
}

.cloud-dot {
  position: absolute;
  top: 100px;
  left: 420px;
  width: 30px;
  height: 30px;
  background-color: rgba(76, 110, 226, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cloud-dot::before {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
}

.cloud-lock {
  position: absolute;
  top: 150px;
  left: 440px;
  font-size: 20px;
  color: #348CF8;
}

.cloud-user {
  position: absolute;
  top: 80px;
  left: 470px;
  font-size: 20px;
  color: #348CF8;
}

.cloud-code {
  position: absolute;
  bottom: 50px;
  right: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #348CF8;
  background-color: white;
  padding: 5px 10px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 100%;
  }
  
  .top-icons {
    gap: 40px;
  }
  
  .main-content {
    gap: 30px;
  }
  
  .process-platform-container {
    gap: 15px;
  }
}

@media (max-width: 992px) {
  .top-icons {
    flex-wrap: wrap;
    gap: 40px 60px;
  }
  
  .main-content {
    flex-direction: column;
    text-align: center;
  }
  
  .advantages-list {
    display: inline-block;
    text-align: left;
  }
  
  .buttons-section {
    justify-content: center;
  }
  
  .cloud-structure {
    transform: scale(0.8);
  }
  
  .process-platform-container {
    flex-direction: column;
    gap: 20px;
  }
  
  .process-card,
  .platform-card {
    max-width: 600px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .top-icons {
    gap: 30px;
  }
  
  .icon-circle {
    width: 60px;
    height: 60px;
  }
  
  .icon-circle i {
    font-size: 24px;
  }
  
  .main-title {
    font-size: 24px;
  }
  
  .advantage-text {
    font-size: 14px;
  }
  
  .cloud-structure {
    transform: scale(0.7);
  }
  
  .process-title,
  .platform-title {
    font-size: 20px;
  }
  
  .process-text,
  .platform-text {
    font-size: 13px;
  }
}
</style>
